module.exports = __webpack_public_path__ + "img/era_device_small.9f2db11f.webp";